import { SingleResponse } from "@/src/core/response"
import { sendRequest } from "@/src/core/http-client"
import Item from "@/src/interfaces/catalog/item"
import ItemInfos from "@/src/interfaces/catalog/item-infos"
import Items from "@/src/interfaces/catalog/items"
import ItemSearch from "@/src/interfaces/catalog/item-search"

export class ItemService {
    static async getItem(merchantId: string, id: string, appAccessToken?: string): Promise<SingleResponse<Item.Response>> {
        return sendRequest<Item.Response>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_CATALOG_URL}/items/${merchantId}/${id}`,
            'GET'
        )
    }

    static async getItemsSummary(param: Items.ItemsSearchParams, appAccessToken?: string): Promise<SingleResponse<Items.ByDataResponse>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_CATALOG_URL}/items/${param.merchantId}/${param.categoryId}/summary`;
        const params = new URLSearchParams();

        params.append('SellOnline', `${!param.sellLocal}`)
        params.append('SellLocal', `${param.sellLocal}`)

        const finalUrl = `${baseUrl}?${params.toString()}`

        return sendRequest<Items.ByDataResponse>(appAccessToken, finalUrl, 'GET')
    }

    static async getListSummary(merchantId: string, ids: string[], sellLocal: boolean, appAccessToken?: string): Promise<SingleResponse<Items.ByDataResponse>> {
        const response = await sendRequest<Items.ByDataResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_CATALOG_URL}/items/${merchantId}/list/summary`,
            'POST',
            {
                ids: ids,
                sellLocal: sellLocal,
                sellOnline: !sellLocal
            },
        )

        if (response.model?.items)
            response.model.items = response.model.items.sort((a, b) => a.name.localeCompare(b.name))

        return response
    }

    static async getBySizeSummary(param: Items.SizeSearchParams, appAccessToken?: string): Promise<SingleResponse<Items.ByDataResponse>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_CATALOG_URL}/items/${param.merchantId}/size/${param.sizeId}/summary`;

        const params = new URLSearchParams();

        params.append('SellOnline', `${!param.sellLocal}`)
        params.append('SellLocal', `${param.sellLocal}`)

        const finalUrl = `${baseUrl}?${params.toString()}`

        return sendRequest<Items.ByDataResponse>(appAccessToken, finalUrl, 'GET', undefined, undefined)
    }

    static async getDetailed(param: ItemInfos.DetailedSearchParams, appAccessToken?: string): Promise<SingleResponse<ItemInfos.DetailedResponse>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_CATALOG_URL}/items/detailed`;

        const params = new URLSearchParams();

        if (param.merchantId) params.append('MerchantId', param.merchantId)
        if (param.id) params.append('Id', param.id)
        if (param.includeWizard) params.append('IncludeWizard', `${param.includeWizard}`)
        if (param.onlyActive) params.append('OnlyActive', `${param.onlyActive}`)

        params.append('SellOnline', `${!param.sellLocal}`)

        const finalUrl = `${baseUrl}?${params.toString()}`

        return sendRequest<ItemInfos.DetailedResponse>(appAccessToken, finalUrl, 'GET', undefined, undefined)
    }

    static async getComplements(param: ItemInfos.ComplementSearchParams, appAccessToken?: string): Promise<SingleResponse<ItemInfos.ComplementsResponse>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_CATALOG_URL}/items/complements`;

        const params = new URLSearchParams();

        if (param.merchantId) params.append('MerchantId', param.merchantId)
        if (param.ids) params.append('Ids', `${param.ids}`)
        if (param.onlyActive) params.append('OnlyActive', `${param.onlyActive}`)

        params.append('SellOnline', `${!param.sellLocal}`)

        const finalUrl = `${baseUrl}?${params.toString()}`

        return sendRequest<ItemInfos.ComplementsResponse>(appAccessToken, finalUrl, 'GET', undefined, undefined)
    }

    static async getBySearchSummary(merchantId: string, search: string, sellLocal: boolean, appAccessToken?: string): Promise<SingleResponse<ItemSearch.SearchResponse>> {
        const response = await sendRequest<ItemSearch.SearchResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_CATALOG_URL}/items/${merchantId}/search/summary`,
            'POST',
            {
                search: search,
                sellLocal: sellLocal,
                sellOnline: !sellLocal
            },
        )

        return response
    }
}